module.exports = __webpack_public_path__ + "static/flags/TW-3ca96615624d47d7587fbe247a812ae9.gif";